exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-image-viewer__mask{cursor:pointer}.el-image-viewer__close{top:80px;width:48px;height:48px;background:rgba(0,0,0,.4)}.el-icon-circle-close:before{content:\"\\E6DB\";color:#fff;font-size:24px;line-height:48px;font-weight:700}.answer-wrap img{max-width:100%}", ""]);

// exports
